import { Grid } from '@mui/material';
import type { FC } from 'react';
import { useShikiHighlighter } from 'react-shiki';

import useAppContext from '../../hooks/useAppContext';

interface CodeBlockProps {
  code: string;
  language: string;
  wrapLongLines?: boolean;
}

const CodeBlock: FC<CodeBlockProps> = ({ code, language, wrapLongLines = false }) => {
  const { theme } = useAppContext();
  const themeMode = theme === 'dark' ? 'github-dark' : 'github-light';
  const highlighted = useShikiHighlighter(code, language, themeMode);

  return (
    <Grid
      component='pre'
      sx={{
        m: 0,
        p: 2,
        borderRadius: 2,
        fontSize: '0.75rem',
        overflowX: wrapLongLines ? 'hidden' : 'auto',
        whiteSpace: wrapLongLines ? 'pre-wrap' : 'pre',
        overflowWrap: wrapLongLines ? 'anywhere' : 'normal',
        wordBreak: wrapLongLines ? 'break-word' : 'normal',
        display: wrapLongLines ? 'block' : 'inline-block',
        backgroundColor: themeContext => themeContext.palette.background.paper,
      }}
    >
      {highlighted}
    </Grid>
  );
};

export default CodeBlock;
